{
  class adaSlider extends HTMLElement {
    disconnectedCallback() {
      if (this.$slick && this.$slick.hasClass('slick-initialized')) {
        this.$slick.slick('unslick')
      }
    }
        
    connectedCallback() {
      this.focusNextUpdate = false

      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      const autoplayOpt = (this.getAttribute('autoplay') === 'true' || (this.hasAttribute('autoplay') && this.getAttribute('autoplay') !== 'false')) && !prefersReducedMotion
      this.autoplaying = autoplayOpt
      this.manualPaused = false
      this.tempPaused   = false

      this.$slick = jQuery(this)

      // Initialize the slick carousel
      this.$slick.slick({
        arrows: false, // Disable default arrows
        dots: false, // Disable default dots
        infinite: true,
        fade: this.getAttribute('effect') === 'fade',
        speed: prefersReducedMotion ? 0 : (parseInt(this.getAttribute('transition-speed')) || 300),
        variableWidth: false,
        autoplay: autoplayOpt,
        autoplaySpeed: parseInt(this.getAttribute('autoplay-speed')) || 2000,
        adaptiveHeight: false,
        centerPadding: this.getAttribute('partially-visible-gap') || 0,
        centerMode: this.hasAttribute('partially-visible-gap') && this.getAttribute('partially-visible-gap')[0] != "0",
        slidesToShow: parseInt(this.getAttribute('slides-per-page')) || 1,
        slidesToScroll: parseInt(this.getAttribute('slides-per-page')) || 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: parseInt(this.getAttribute('slides-per-page-tablet')) || 1,
              slidesToScroll: parseInt(this.getAttribute('slides-per-page-tablet')) || 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: parseInt(this.getAttribute('slides-per-page-mobile')) || 1,
              slidesToScroll: parseInt(this.getAttribute('slides-per-page-mobile')) || 1,
              centerMode: false,
              centerPadding: '0px',
            }
          }
        ]

      });

      // Slick injects its own autoplay toggle button; ada-slider provides a custom control, so remove Slick's
      this.querySelector('.slick-autoplay-toggle-button')?.remove()

      this.$slick
        .on('mouseenter', () => {
          if (this.autoplaying) {
            this.pause()
            this.tempPaused = true
          }
        })
        .on('mouseleave', () => {
          if (this.tempPaused && !this.manualPaused) {
            this.play()
            this.tempPaused = false
          }
        })


      this.addEventListener('focusin', () => {
        if (this.autoplaying) {
          this.pause()
          this.tempPaused = true
        }
      })

      this.addEventListener('focusout', () => {
        if (this.tempPaused && !this.manualPaused) {
          this.play()
          this.tempPaused = false
        }
      })

      if (this.autoplaying && !document.querySelector(`[is="ada-slider-autoplay-control"][aria-controls="${this.id}"]`)) {
        console.warn(`ada-slider#${this.id}: autoplay is on but no <ada-slider-autoplay-control> found`)
      }

      // Custom navigation
      document.addEventListener('click', e => {
        const btn = e.target.closest(`[aria-controls="${this.id}"]`)
        if (!btn) return

        const type = btn.getAttribute('is')
        if (type === 'ada-slider-autoplay-control') return

        if (['ada-slider-prev','ada-slider-next','ada-slider-page'].includes(type)) {
          // navigate first…
          if (type === 'ada-slider-prev') {
            this.$slick.slick('slickPrev')
          } else if (type === 'ada-slider-next') {
            this.$slick.slick('slickNext')
          } else {
            this.$slick.slick('slickGoTo', parseInt(btn.getAttribute('index')))
          }

          // then permanently pause
          this.manualPaused = true
          this.pause()
        }
      })


      // // Initialize pagination on slide change
      this.$slick.on('afterChange', (event, slick, currentSlide) => {
        this.turnOffInactiveVideos()
        this.updatePagination()
      })

      // // Set initial pagination text
      this.updatePagination();
    }

    turnOffInactiveVideos(){
      this.querySelectorAll('iframe').forEach(iframe => {
        if (!iframe.closest('.slick-active') && iframe.src) {
          let command = {
            "event": "command",
            "func": "pauseVideo"
          }
          if(iframe.src.indexOf('vimeo') != -1) {
            command = {
              "method": "pause",
              "value": "true"
            }
          }
          iframe.contentWindow.postMessage(JSON.stringify(command), "*")
        }
      })
    }

    updatePagination() {
      const currentSlideIndex = this.$slick.slick('slickCurrentSlide')
      const currentSlide = this.querySelector(`[data-slick-index="${currentSlideIndex}"]`)
      const slidesToScroll = this.$slick.slick('getSlick').options.slidesToScroll
      const totalPageButtons = Math.ceil(this.$slick.slick('getSlick').slideCount / slidesToScroll)
      const currentPage = Math.ceil((currentSlideIndex + 1) / slidesToScroll)

      if(totalPageButtons < 2){
        document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(el => el.style.display = 'none')
        return
      } else {
        document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(el => el.style.display = '')
      }

      document.querySelectorAll(`[is="ada-slider-page"][aria-controls="${this.id}"]`).forEach(pager => {
        pager.setAttribute('aria-current', false)
        pager.style.display = 'none'
      })

      for (let i = 0; i < totalPageButtons; i++) {
        const pagerIndex = i * slidesToScroll; // Calculate index for buttons
        const pager = document.querySelector(`[is="ada-slider-page"][aria-controls="${this.id}"][index="${pagerIndex}"]`);
        if (pager) {
          pager.style.display = ''; // Show only relevant buttons
          pager.setAttribute('aria-current', (i === Math.floor(currentSlideIndex / slidesToScroll)) ? 'true' : 'false');
        }
      }

      // Calculate visible range — default to "all visible" when no page dots are present
      const allPages = Array.from(document.querySelectorAll(`[is="ada-slider-page"][aria-controls="${this.id}"]`))
      const allVisible = allPages.length ? allPages.length === totalPageButtons : true

      // Update pagination text — runs regardless of page dots so the aria-live announcer stays accurate
      document.querySelectorAll(`ada-slider-pagination-text[aria-controls="${this.id}"]`).forEach(pt => {
        const template = pt.getAttribute('template')
        let formatted = template.replace(/\{([^|]+)\|([^}]+)\}/g, (_, part1, part2) => {
          return allVisible ? part1 : part2
        })
        formatted = formatted
          .replaceAll("{x}", currentPage)
          .replaceAll('{y}', totalPageButtons)
        pt.textContent = formatted
      })

      if(this.focusNextUpdate){
        this.focusNextUpdate = false
        setTimeout(() => {
          const focusable = currentSlide.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
          if(focusable){
            focusable.focus()
          }
        })
      }
    }
 

    pause() {
      this.$slick.slick('slickPause')
      this.autoplaying = false
      this.dispatchEvent(new CustomEvent('ada-slider:autoplay-change'))
    }

    play() {
      this.$slick.slick('slickPlay')
      this.autoplaying = true
      this.dispatchEvent(new CustomEvent('ada-slider:autoplay-change'))
    }

    goToSlide(index){
      this.$slick.slick('slickGoTo', parseInt(index))
    }
  }

  class adaSliderPaginationText extends HTMLElement {
    connectedCallback() {
      this.setAttribute('aria-live', 'polite')

      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }
    }
  }

  class adaSliderPrev extends HTMLElement {
    connectedCallback() {
      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }
    }
  }

  class adaSliderNext extends HTMLElement {
    connectedCallback() {
      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }
    }
  }

  class adaSliderPage extends HTMLElement {
    connectedCallback() {
      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }
    }
  }      

  // adaSliderAutoplayControl
  class adaSliderAutoplayControl extends HTMLButtonElement {
    connectedCallback() {
      this.slider = document.getElementById(this.getAttribute('aria-controls'))
      this._explicitLabel = this.hasAttribute('aria-label')

      if (!this.slider) return

      if (!this.slider.$slick) {
        this.slider.addEventListener('ada-slider:init', () => this.updateIcon(), { once: true })
      }   

      this.addEventListener('click', () => {
        if (this.slider.autoplaying) {
          this.slider.manualPaused = true
          this.slider.pause()
        } else {
          this.slider.manualPaused = false
          this.slider.play()
        }
        this.updateIcon()
      })

      this.slider.addEventListener('ada-slider:autoplay-change', () => this.updateIcon())

      this.updateIcon()
    }
    updateIcon() {
      const playing = this.slider.autoplaying
      this.setAttribute('aria-pressed', playing ? 'true' : 'false')
      if (!this._explicitLabel) this.setAttribute('aria-label',
        playing ? 'Pause Slides' : 'Play Slides'
      )
      this.innerHTML = playing
        ? '<svg viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><rect x="3" y="2" width="3.5" height="12" rx="0.5"/><rect x="9.5" y="2" width="3.5" height="12" rx="0.5"/></svg>'
        : '<svg viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><path d="M4 2.5v11a.5.5 0 0 0 .76.43l9-5.5a.5.5 0 0 0 0-.86l-9-5.5A.5.5 0 0 0 4 2.5Z"/></svg>'
    }
  }



  customElements.define("ada-slider", adaSlider)
  customElements.define("ada-slider-pagination-text", adaSliderPaginationText)
  customElements.define("ada-slider-prev", adaSliderPrev)
  customElements.define("ada-slider-next", adaSliderNext)
  customElements.define("ada-slider-page", adaSliderPage)
  customElements.define('ada-slider-autoplay-control', adaSliderAutoplayControl, { extends: 'button' })
}